// perf.web
// ========

export class WebPerf {
  now (): number {
    return performance.now()
  }
}
